import { Table } from '@mui/material'
import type { ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material'
interface ISimpleTableProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export default function SimpleTable({ children, sx }: ISimpleTableProps) {
  return <Table sx={{ ...sx, borderRadius: 2, overflow: 'hidden' }}>{children}</Table>
}
